import type { ModuleDef } from '@pmai/contracts';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useMe } from '../shared/auth/session';
import { useDocumentTitle } from '../shared/use-document-title';
import { ForbiddenPage, NoWorkspacePage } from '../shared/system-pages';

/**
 * Page guard + title for every registry page (FR-WS-008): without the module's permission the
 * page is not rendered, even by direct URL. The API enforces the same permission (403).
 */
export function ModulePage({ module, children }: { module: ModuleDef; children: ReactNode }) {
  const { t } = useTranslation();
  const me = useMe();
  useDocumentTitle(t(module.labelKey));
  if (module.permission !== null && me.workspace === null) return <NoWorkspacePage />;
  if (module.permission !== null && !me.permissions.includes(module.permission)) return <ForbiddenPage />;
  return children;
}
